import React, { useState } from 'react';
import { Box, Divider, Typography, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { MobileHeader1 } from '@theme/styledComponents';
import { MobileMenuComponent } from 'components/Mobile/MenuComponent';
import { MobileMenuButton } from './MobileMenuButton';

const StyledPageBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  padding: theme.spacing(4),
}));

const StyledDivider = styled(Divider)({
  marginTop: '3.5rem',
});

const StyledFooterBox = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(4),
}));

const StyledTitle = styled(MobileHeader1)(({ theme }) => ({
  marginTop: '12rem',
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
}));

const StyledContentBox = styled(Box)(({ theme }) => ({
  marginTop: '4.2rem',
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
}));

type MobilePageContainerProps = {
  children: React.ReactNode;
  title: string;
  footerText?: string;
  footerUrl?: string;
  showLanguageSelector?: boolean;
};

export const MobilePageContainer = ({ children, title, footerText, footerUrl, showLanguageSelector = false }: MobilePageContainerProps) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <StyledPageBox>
      <MobileMenuButton
        onClick={() => setMenuOpen(true)}
        logoOnly={false}
        showLanguageSelector={showLanguageSelector}
      />
      <MobileMenuComponent open={menuOpen} onClose={() => setMenuOpen(false)} />
      <StyledTitle>
        {title}
      </StyledTitle>

      <StyledContentBox>
        {children}
      </StyledContentBox>

      {footerText && footerUrl && (
        <>
          <StyledDivider />
          <StyledFooterBox>
            <Link to={footerUrl}>
              <Typography textAlign="center">{footerText}</Typography>
            </Link>
          </StyledFooterBox>
        </>
      )}
    </StyledPageBox>
  );
};
